<template>
  <el-dialog :title="dialogType==='add'?'添加演员信息':dialogType==='look'?'查看演员信息':'编辑演员信息'" :before-close="close" :visible.sync="show" width="400px" center>
    <el-form v-if="show" :model="form" label-position="left" ref="form" :rules="rules">
        <el-form-item label="演员名称" :label-width="formLabelWidth" style="width: 100%" prop="name">
          <el-input v-model="form.name" placeholder="请输入演员名称" :disabled="dialogType==='look'"></el-input>
        </el-form-item>
        <el-form-item label="演员类型" :label-width="formLabelWidth" prop="type">
          <el-select v-model="form.type" placeholder="请选择演员类型" prop="type" style="width: 100%" :disabled="dialogType==='look'">
              <el-option label="自定义" :value="0"></el-option>
              <el-option label="女优" :value="1"></el-option>
              <el-option label="网黄" :value="2"></el-option>
              <el-option label="博主" :value="3"></el-option>
          </el-select>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$parent.addFrom = false">取 消</el-button>
      <el-button type="primary" @click="submit" :disabled="dialogType==='look'">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api'
export default {
  name: "addForm",
  props:['show','projectList','userList','data','disabledType','dialogType'],
  data() {
    return {
      formLabelWidth:'110px',
      form:{
        account:'',
        account_type:'',
      },
      rules: {
        name: [
          { required: true, message: '请输入演员名称', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择演员类型', trigger: 'change' }
        ],
      },
    }
  },
  created() {
  },
  watch:{
    data(data){
      this.form = data
      if(this.dialogType!=='add'){
        this.form.password = ""
      }
    },

  },
  methods:{
    submit(){
      this.$refs.form.validate((valid) => {
        if(valid){
          !this.form.id ? this.addActor() : this.updateActor()
        }
      });
    },
    async updateActor(){
       let json = {
        name:this.form.name,
        type:this.form.type,
        id: this.form.id,
      };
      const {code,msg} = await API.updateActor(json) 
      if(!code){
        this.$message({ message: '更新成功！', type:'success'})
        this.$parent.closeAdd()
      }else{
        this.$message({ message: msg, type:'error'})
        this.$parent.closeAdd()
      }
    },
    async addActor(){
      let json = {
        name: this.form.name,
        type: this.form.type,
      };
      const {code,msg} = await API.addActor(json) 
      if(!code){
        this.$message({ message: '创建成功！', type:'success'})
        this.$parent.closeAdd()
      }else{
        this.$message({ message: msg, type:'error'})
        this.$parent.closeAdd()
      }
    },
    close() {
      this.$emit("clearData");
    },
  }
}
</script>

<style scoped type="scss">
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
::v-deep input[type="number"] {
    -moz-appearance: textfield;
}
::v-deep inpit {
    border: none
}
</style>
